import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError, timeout } from 'rxjs';
import { CanActivateFn, Router } from '@angular/router';
import { ConnectServerService } from '../services/connect-server.service';
import { AuthService } from '../services/auth.service';
import { PopupDialogService } from '../services/popup-dialog.service';
import { ApiResponse } from '../interfaces/api-response';

export const requestErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const connectServerService = inject(ConnectServerService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const popupDialogService = inject(PopupDialogService);
  // Variabili per tracciare l'ultimo errore e l'ultimo tempo del popup
  let lastErrorMessage: string | null = null;
  let lastErrorTimestamp: number | null = null;
  const popupDelay = 5000; // Intervallo di tempo minimo tra i popup (in millisecondi)
  return next(req).pipe(
    timeout({ each: connectServerService.getTimeoutForRequest(req), with: () => throwError(() => new Error('Timeout della richiesta')) }),
    catchError((error: HttpErrorResponse | any) => {
      // Default error message
      let errorMessage = 'An unknown error occurred';
      let code = 544;
      let not_popup = 0; // se 1 non voglio il popup
      let obj_dialog = null;
      // Handle client-side errors
      if (error.error instanceof ErrorEvent) {
        errorMessage = `Client-side error: ${error.error.message}`;
      } else {
        // Handle server-side errors
        errorMessage = `Server-side error: ${error.status} - ${error.message}`;
        switch (error.status) {
          case 400:
            // Bad Request
            errorMessage = `Bad Request: ${error.error.message || error.message}`;
            code = 400;
            break;
          case 401:
            // Unauthorized
            errorMessage = 'Unauthorized access. Please log in.';
            // vai alla home ma anche cancella token
            authService.removeLocalAuth();
            // router.navigate(['/home']);
            window.location.href = '/home';
            not_popup = 1;
            code = 401;
            break;
          case 403:
            // Forbidden
            errorMessage = 'You do not have permission to perform this action.';
            code = 403;
            break;
          case 404:
            // Not Found
            errorMessage = 'The requested resource was not found.';
            code = 404;
            break;
          case 500:
            // Internal Server Error
            errorMessage = 'An internal server error occurred. Please try again later.';
            code = 500;
            break;
          default:
            // Other errors
            errorMessage = `Generic error! If it persists, contact the supplier.`;
            // console.log(`Unexpected error: ${error.message}`);
        }
        if((error.error && error.error.message) || error.message){
          errorMessage = `${error.error.message || error.message}`;
        }
        if ((error.error && error.error.obj_dialog) || error.obj_dialog) {
          obj_dialog = error.error.obj_dialog || error.obj_dialog;
        }
      }

      // Log the error to the console
      // console.error(errorMessage);
      const currentTime = Date.now();
      const obj_request: ApiResponse<any> = {
        code: code,
        data: {},
        title: 'Error',
        message: errorMessage,
        obj_dialog: obj_dialog
      }
      // if (not_popup == 0) {
      //   popupDialogService.popupDialog(obj_request);
      // }
      if (not_popup == 0 && (!lastErrorMessage || lastErrorMessage !== errorMessage || (lastErrorTimestamp && currentTime - lastErrorTimestamp > popupDelay))) {
        popupDialogService.popupDialog(obj_request);
        lastErrorMessage = errorMessage;
        lastErrorTimestamp = currentTime;
      }

      // Return an observable with a user-facing error message
      return throwError(() => new Error(errorMessage));
    })
  );
};
